var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-text-element mb-7",attrs:{"id":_vm.item.key}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 offset-md-1"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.item.rteText)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }